






import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Gallery from "@/components/Gallery.vue";

@Component({
  name: "Other",
  components: {
    Gallery
  }
})
export default class Other extends Vue {
  // eslint-disable-next-line
  @Prop() private assets!: any;
}
